<template>
  <vue-iframe
    :src="src"
    allow="camera *; geolocation *; microphone *; autoplay *"
    frame-id="my-ifram"
    @load="onLoad"
    name="my-frame"
    :width="`${this.attributes.width}`"
    :height="`${this.attributes.height}`"
  />
</template>

<script>
import Bus from "../services/bus.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
export default {
  name: "MyIframe",
  mixins: [dataComponentMixin],
  data: () => ({
    myIframe: null,
    source: "",
    src: "",
  }),
  async mounted() {
    this.src = `${this.IREALCONFIG.static_ressources}/labs/${this.$store.getters.experienceIdentifier}/${this.flux_identifier}_poster.jpg`;

    // catch the program "ireal-start" ( send by the mutation store )
    Bus.$on("ireal-start", async () => {
      this.source = await this.getObservationVideo();
      this.src = this.source.video_path_hd;
      this.$store.commit("test", this.source.parameters);

      this.onLoad();

      if (this.src === undefined) {
        console.log("Erreur lors de la récupération du flux de résultat");
        return;
      }
    });
  },
  methods: {
    onLoad(frame) {
      this.myIframe = document.getElementById("my-ifram");
      this.myIframe.width =
        this.myIframe.contentWindow.document.body.scrollWidth;
      this.myIframe.height =
        this.myIframe.contentWindow.document.body.scrollWidth * 2;

      var parentIframe = document.getElementsByClassName("vue-iframe")[0];
      parentIframe.style.width = this.myIframe.width;
      parentIframe.style.height = this.myIframe.height;
    },
  },
};
</script>
<style scoped>
.md-card-content {
  height: 700px !important;
}
.graphic {
  font-size: 12px;
  padding-left: 1em;
}
.md-progress-spinner-circle svg {
  stroke: blue !important;
}
.block_graph {
  position: relative;
  width: 100%;
  height: 100%;
}
.block_parent_spinner {
  position: absolute;
  width: 100%;
  height: 100%;
}
.block_spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lds-ring {
  display: inline-block;
  position: absolute;
  width: 80px;
  height: 80px;
  left: 45%;
  top: 50%;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #068bea;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #068bea transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#cesiumContainer {
  height: 700px !important;
}
.cesium-viewer {
  height: 400px;
}
</style>
